import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'movimiento_animal'

const MovimientoAnimalRepository = {
  crearMovimientoAnimal(idFichaGanadera,idTipoMovimientoAnimal,fecha,comentario,detalleMovimiento,idSubconcepto){
    let data = {
      idFichaGanadera,
      idTipoMovimientoAnimal,
      fecha,
      comentario,
      detalleMovimiento
    }
    if(idSubconcepto){
      data['idSubconcepto'] = idSubconcepto
    }
    return ApiService.post(`${REPOSITORY_URL}/crear`, data)
  },

  actualizarMovimientoAnimal(idMovimientoAnimal,fecha,comentario,detalleMovimiento){
    let data = {
      idMovimientoAnimal,
      fecha,
      comentario,
      detalleMovimiento
    }
    return ApiService.post(`${REPOSITORY_URL}/actualizar`, data)
  },

  borrarMovimientoAnimal(idMovimientoAnimal){
    let data = {
      idMovimientoAnimal
    }
    return ApiService.post(`${REPOSITORY_URL}/borrar`, data)
  },

  listaMovimientosAnimal(idFichaGanadera,idTipoMovimientoAnimal,fechaDesde,fechaHasta){
    let data = {
      idFichaGanadera,
      idTipoMovimientoAnimal,
      fechaDesde,
      fechaHasta
    }
    return ApiService.get(`${REPOSITORY_URL}/lista_movimiento`, data)
  },
}

export default MovimientoAnimalRepository